import React, { useState } from "react";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import type { ExportModalEntity } from "./types";

export interface EntityCardProps {
  entity: ExportModalEntity;
  informationAvailableContent?: React.ReactNode;
  selectable?: boolean;
  selected?: boolean;
  onSelectEntity?: (entityId: string, selected: boolean) => void;
  selectedCount?: number;
}

const ENTITY_PROFILE_PATH = "/entity";

export function EntityCard({
  entity,
  informationAvailableContent,
  selectable = false,
  selected = false,
  onSelectEntity,
  selectedCount = 0,
}: EntityCardProps): React.ReactElement {
  const [expanded, setExpanded] = useState(false);
  const viewEntityUrl = `${ENTITY_PROFILE_PATH}/${entity.id}/dashboard`;
  const toggleLabel =
    selectedCount > 0
      ? `Information Available (${selectedCount})`
      : "Information Available";

  return (
    <div className="export-entity-card">
      <div className="export-entity-card__main">
        {selectable && onSelectEntity && (
          <div className="export-entity-card__select">
            <Checkbox
              inputId={`entity-${entity.id}`}
              checked={selected}
              onChange={(e) => onSelectEntity(entity.id, e.checked === true)}
            />
          </div>
        )}
        <div className="export-entity-card__info">
          <span className="export-entity-card__name">
            {entity.name ?? "Unnamed"}
          </span>
          <div className="export-entity-card__meta">
            {entity.country != null && (
              <span className="export-entity-card__country">
                <ReactCountryFlag
                  countryCode={entity.country}
                  svg
                  className="export-entity-card__flag"
                />
                {getName(entity.country) ?? entity.country}
              </span>
            )}
            {entity.country != null && entity.type != null && (
              <span className="export-entity-card__separator">|</span>
            )}
            {entity.type != null && (
              <span className="export-entity-card__type">{entity.type}</span>
            )}
          </div>
        </div>
        <div className="export-entity-card__actions">
          <a
            href={viewEntityUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="export-entity-card__link"
          >
            View Entity <i className="pi pi-external-link" />
          </a>
        </div>
      </div>
      <Divider className="export-entity-card__divider" />
      <div className="export-entity-card__toggle-row">
        <button
          type="button"
          className="export-entity-card__toggle"
          onClick={() => setExpanded((prev) => !prev)}
        >
          <span className="export-entity-card__toggle-label">
            {toggleLabel}
          </span>
          <i
            className={`pi ${expanded ? "pi-chevron-up" : "pi-chevron-down"}`}
          />
        </button>
      </div>
      {expanded && (
        <div className="export-entity-card__content">
          {informationAvailableContent ?? (
            <p className="export-entity-card__placeholder">
              No datasets available.
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default EntityCard;
